import React from "react";
import InfoCard from "./InfoCard";

interface IProps {
  pSectionNumber?: string | number;
  pSectionLabel?: string | number;
  children: React.ReactNode;
  infobulle?: string;
}
const CpntFormSection: React.FC<IProps> = ({
  pSectionNumber = null,
  pSectionLabel = null,
  children,
  infobulle,
}) => {
  return (
    <div className="card-body form-container">
      {(pSectionNumber || pSectionLabel) && (
        <div className="d-flex">
          <p className="h6lpe me-4">
            <b>
              {pSectionNumber && (
                <span className="badge rounded-pill bg-secondary me-2">
                  {pSectionNumber}
                </span>
              )}
              {pSectionLabel}
            </b>
          </p>
          {infobulle && <InfoCard content={infobulle} />}
        </div>
      )}

      {React.Children.map(children, (child, i) => {
        if (child) {
          return <div key={"CpntFormSection" + i}>{child}</div>;
        }
      })}
    </div>
  );
};

export default CpntFormSection;
